import { Separator } from "@/components/ui";
import { Callout } from "@/components/ui/Callout";
import { SectionContent } from "@/features/Patient/MedicalRecords/components/SectionContent";
import { SectionHeader } from "@/features/Patient/MedicalRecords/components/SectionHeader";
import { useGetGenericObservations } from "@/network/useGenericObservations";
import type { ObservationGroupItem } from "@/types/observations";
import { useParams } from "@tanstack/react-router";
import { Fragment } from "react";
import { GenericObservationEditor } from "../components/GenericObservationEditor";
import { SexualHistorySkeleton } from "./SexualHistorySkeleton";

const GROUP_IDENTIFIER = "sexual-history";

export const SexualHistory = () => {
  const { patientId } = useParams({ strict: false });
  const {
    data: groupItems,
    isLoading,
    isError: isErrorGroupItems,
    refetch,
  } = useGetGenericObservations(patientId, GROUP_IDENTIFIER);

  const isError = !isLoading && (isErrorGroupItems || !groupItems);
  const isSuccess = !isLoading && !isError && groupItems;

  return (
    <div className="w-full h-full flex flex-col">
      <SectionHeader title="Sexual History" />
      <SectionContent>
        {isLoading && <SexualHistorySkeleton />}
        {isError && (
          <div className="flex flex-col gap-2 py-2 w-full">
            <Callout
              className="w-full cursor-pointer"
              variant="danger"
              title="Unable to load sexual history data!"
              description="Please click here to try again."
              onClick={() => refetch()}
            />
          </div>
        )}
        {isSuccess && (
          <div className="flex flex-wrap w-full">
            {groupItems.items.map(
              (item: ObservationGroupItem, index: number) => (
                <Fragment key={item.observationCode}>
                  <div className="w-1/2">
                    <GenericObservationEditor
                      item={item}
                      itemCategory="social-history"
                      group={GROUP_IDENTIFIER}
                    />
                  </div>
                  {(index + 1) % 2 === 0 && <Separator className="w-full" />}
                </Fragment>
              ),
            )}
          </div>
        )}
      </SectionContent>
    </div>
  );
};
